var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ak-relation-data-table d-flex flex-column full-height" },
    [
      _c("ak-data-table", {
        ref: "dataTable",
        attrs: {
          bundle: _vm.bundle,
          definition: _vm.definition,
          relation: _vm.relation,
          idsSelected: _vm.defaultIdsSelected,
          infiniteScroll: false,
          query: _vm.queryForRelationTable,
          compactFilters: true,
        },
        on: {
          selectionChanged: _vm.updateSelection,
          edit: _vm.updateRelationString,
          new: _vm.updateRelationString,
        },
        scopedSlots: _vm._u(
          [
            _vm.isListView
              ? {
                  key: "default",
                  fn: function (slotProps) {
                    return [
                      _c("ak-data-list", {
                        attrs: {
                          dataObjects: slotProps.dataObjects,
                          selectables: slotProps.selectables,
                          selection: slotProps.selection,
                          isUpdating: slotProps.isUpdating,
                          sortingEnabled: slotProps.sortingEnabled,
                          pageJumper: slotProps.pageJumper,
                          widgetCallbackUri: slotProps.baseGridUri,
                          numberOfTilesPerRow: slotProps.numberOfTilesPerRow,
                        },
                        on: {
                          edit: slotProps.handleEdit,
                          delete: slotProps.handleDelete,
                          sortColumn: function ($event) {
                            return slotProps.sortColumn($event)
                          },
                          changeList: function ($event) {
                            slotProps.dataObjects = $event
                          },
                          sort: function ($event) {
                            return slotProps.submitNewSorting($event)
                          },
                          refresh: slotProps.refresh,
                          export: slotProps.triggerExport,
                        },
                      }),
                    ]
                  },
                }
              : null,
            {
              key: "idle-widgets",
              fn: function (ref) {
                var idleWidgets = ref.idleWidgets
                var baseGridUri = ref.baseGridUri
                var handleNew = ref.handleNew
                var contextualPageJumperWidgets =
                  ref.contextualPageJumperWidgets
                return [
                  _c("div", { staticClass: "ak-data-table__idle-widgets" }, [
                    _c(
                      "div",
                      { staticClass: "ak-button-group flex-grow-1" },
                      [
                        _vm._l(idleWidgets.list, function (widget) {
                          return _c("ak-widget", {
                            key: widget.id,
                            attrs: {
                              slot: widget.slot,
                              type: widget.type,
                              attributes: Object.assign({}, widget.attributes, {
                                id: widget.id,
                              }),
                              callbacks: widget.callbacks,
                              callbackUri: baseGridUri,
                              contextType: idleWidgets.contextType,
                            },
                            on: { new: handleNew },
                            slot: widget.slot,
                          })
                        }),
                        _vm._v(" "),
                        _c(
                          "ak-button",
                          {
                            staticClass: "m-l-auto",
                            attrs: { disableBackground: true },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.cancel.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("Annuleren")) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "ak-button",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.save.apply(null, arguments)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t("Opslaan")) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ],
                      2
                    ),
                  ]),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _vm.childRelationString
        ? _c("ak-relation-resolver", {
            attrs: { relationString: _vm.childRelationString },
            on: { close: _vm.triggerClose, refresh: _vm.refresh },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }